export const BACK_BUTTON_CONTAINER_ID = 'back-button-container';
